import React, { FC, ReactElement } from 'react'
import cx from 'classnames'
import { Icon } from 'components/Icon'
import styles from './Alert.module.scss'

export const TONES = ['neutral', 'info', 'positive', 'caution', 'critical'] as const
export type AlertTone = typeof TONES[number]

type AlertProps = {
  tone?: AlertTone
  icon?: ReactElement
  full?: boolean
}

const ICONS = {
  info: 'information-line',
  positive: 'check-line',
  caution: 'alarm-warning-line',
  critical: 'alert-line',
  neutral: '',
}

export const Alert: FC<AlertProps> = ({
  children,
  icon,
  tone = 'neutral',
  full = false,
  ...rest
}) => {
  const classes = cx({
    [styles.alert]: true,
    [styles[tone]]: true,
    [styles.full]: full,
  })

  const type = ['caution', 'critical'].includes(tone) ? 'assertive' : 'polite'
  const role = type === 'assertive' ? 'alert' : 'status'

  const renderIcon = () => {
    if (icon) return icon
    if (ICONS[tone] !== '') return <Icon name={ICONS[tone]} />
    return null
  }

  return (
    <div role={role} aria-live={type} className={classes} {...rest}>
      {renderIcon()}
      {children}
    </div>
  )
}

Alert.displayName = 'Alert'
